
/**
 * Created by 2019.3.20
 */
import httpUrl from './baseUrl'//接口地址
import http from './http.js'

//登录
export const login = (ajax) =>( http.post('back_login/ajax',ajax));
//获取城市
export const city_ztree = (get_citys) =>( http.post_token('back_companys/get_citys',get_citys));
//获取诊所列表
export const company_list = (company_list) =>( http.post_token('back_companys/company_list',company_list));
//获取诊所单条数据
export const company_row = (company_row) =>( http.post_token('back_companys/company_row',company_row));
//删除诊所单条数据
export const company_delete = (company_delete) =>( http.post_token('back_companys/company_delete',company_delete));
//修改诊所信息
export const company_save = (company_save) =>( http.post_token('back_companys/company_save',company_save));
//图片上传
export const imgbase64upload = (img_base64_upload) =>( http.post_token('back_users/img_base64_upload',img_base64_upload));
//用户列表
export const users_list = (users_list) =>( http.post_token('back_users/users_list',users_list));
//用户个人信息
export const users_row = (user_row) =>( http.post_token('back_users/user_row',user_row));
//添加用户
export const user_save = (user_save) =>( http.post_token('back_users/user_save',user_save));
//查询
export const user_row = (user_row) =>( http.post_token('back_users/user_row',user_row));
//用户认证
export const checked_users = (checked_users) =>( http.post_token('back_users/checked_users',checked_users));
//诊所认证
export const renzheng_company = (renzheng_company) =>( http.post_token('back_companys/renzheng_company',renzheng_company));
//诊所下成员
export const users_list_company = (users_list_company) =>( http.post_token('back_users/users_list_company',users_list_company));
//邀请个人
export const get_company = (get_invite_by_company) =>( http.post_token('back_companys/get_invite_by_company',get_invite_by_company));
//设置双重身份
export const set_dual_status = (set_dual_status) =>( http.post_token('back_users/set_dual_status',set_dual_status));
export const set_dual_status_new = (set_dual_status_new) =>( http.post_token('back_users/set_dual_status_new',set_dual_status_new));
//删除企业用户
export const delete_from_company = (users_delete_from_company) =>( http.post_token('back_companys/users_delete_from_company',users_delete_from_company));
//手机号登陆
export const login_by_tel = (login_by_tel) =>( http.post('login/login_by_tel',login_by_tel));
//个人注册
export const users_reg = (users_reg) =>( http.post('login/users_reg',users_reg));
//设置专家
export const set_expert_status = (set_expert_status) =>( http.post_token('back_users/set_expert_status',set_expert_status));


//企业注册
export const company_reg = (company_reg) =>( http.post('login/company_reg',company_reg));
//注册短信验证码
export const send_msg_reg = (send_msg_reg) =>( http.post('login/send_msg_reg',send_msg_reg));
//登陆短信验证码
export const send_msg_login = (send_msg_login) =>( http.post('login/send_msg_login',send_msg_login));
//============================================
//获取邀请状态
export const get_invite_list_for_user = (get_invite_list_for_user) =>( http.post_token('users/get_invite_list_for_user',get_invite_list_for_user));
//处理状态
export const set_invite_chk = (set_invite_chk) =>( http.post_token('users/set_invite_chk',set_invite_chk));
//患者列表
export const patient_list = (patient_list)=>(http.post_token('users/patient_list',patient_list));
//预约列表
export const appointment_list = (appointment_list)=>(http.post_token('users/appointments_list',appointment_list));

//预约列表
export const users_appointments_list = (users_appointments_list) =>( http.post_token('users_appointments/users_appointments_list',users_appointments_list));
//添加预约信息
export const users_appointments_save = (users_appointments_save) =>( http.post_token('users_appointments/users_appointments_save',users_appointments_save));
//查看单条预约信息
export const users_appointments_row = (users_appointments_row) =>( http.post_token('users_appointments/users_appointments_row',users_appointments_row));
//删除预约信息
export const users_appointments_delete = (users_appointments_delete) =>( http.post_token('users_appointments/users_appointments_delete',users_appointments_delete));

//添加用户数据
export const users_update_for_login = (users_update_for_login)=>(http.post_token('users/users_update_for_login',users_update_for_login));

//更新密码
export const user_update_pwd = (user_update_pwd)=>(http.post_token('users/user_update_pwd',user_update_pwd));
//绑定邮箱
export const user_update_email = (user_update_email)=>(http.post_token('users/user_update_email',user_update_email));
//
//更新手机号码
export const send_msg_by_oldTel = (send_msg_by_oldTel)=>(http.post_token('users/send_msg_by_oldTel',send_msg_by_oldTel));
export const user_update_tel = (user_update_tel)=>(http.post_token('users/user_update_tel',user_update_tel));
//更换手机号 验证码
export const send_msg = (send_msg) =>( http.post_token('users/send_msg',send_msg));
//获取个人信息
export const get_users_row = (get_users_row) =>( http.post_token('users/get_users_row',get_users_row));
//修改诊所信息
export const companys_save = (companys_save) =>( http.post_token('companys/companys_save',companys_save));
//设置出诊日
export const set_work_data = (set_work_data) =>( http.post_token('users/set_work_data',set_work_data));
//设置出诊日一致
export const set_work_data_for_month = (set_work_data_for_month) =>( http.post_token('users/set_work_data_for_month',set_work_data_for_month));
//获取出诊日
export const get_work_days = (get_work_days) =>( http.post_token('users/get_work_days',get_work_days));
//删除团队成员
export const users_delete_from_company = (users_delete_from_company) =>( http.post_token('users/users_delete_from_company',users_delete_from_company));
//重置密码
export const user_resetpwd = (user_resetpwd) =>( http.post_token('back_users/user_resetpwd',user_resetpwd));
//删除团队
export const company_deletes = (company_delete) =>( http.post_token('back_companys/company_delete',company_delete));
//注册人数
export const user_count = (user_count) =>( http.post_token('back_users/user_count',user_count));
//统计数据
export const ystj_count = (ystj_count) =>( http.post_token('back_users/ystj_count',ystj_count));
//医生每日新曾
export const yhrx_zcxz = (yhrx_zcxz) =>( http.post_token('back_users/yhrx_zcxz',yhrx_zcxz));
//医护每日注册总数
export const yhrx_zczs = (yhrx_zczs) =>( http.post_token('back_users/yhrx_zczs',yhrx_zczs));
//医护每日认证新增
export const yhrx__rzxz = (yhrx__rzxz) =>( http.post_token('back_users/yhrx__rzxz',yhrx__rzxz));
//医护每日认证总数
export const yhrx_rzzs = (yhrx_rzzs) =>( http.post_token('back_users/yhrx_rzzs',yhrx_rzzs));
//医生和助理认证对比统计
export const yhrx_yzdb = (yhrx_yzdb) =>( http.post_token('back_users/yhrx_yzdb',yhrx_yzdb));
// 门诊统计
export const mztj_count = (mztj_count) =>( http.post_token('back_users/mztj_count',mztj_count));
// 门诊注册总数统计
export const mz_zczs = (mz_zczs) =>( http.post_token('back_users/mz_zczs',mz_zczs));
//患者统计数据
export const hztj_count = (hztj_count) =>( http.post_token('back_users/hztj_count',hztj_count));
//患者注册总人数
export const hz_zczrs = (hz_zczrs) =>( http.post_token('back_users/hz_zczrs',hz_zczrs));
//pdm录入
export const pdm_lrzrs = (pdm_lrzrs) =>( http.post_token('back_users/pdm_lrzrs',pdm_lrzrs));
//微信授权
export const hxsqrs = (hxsqrs) =>( http.post_token('back_users/hxsqrs',hxsqrs));
//激活患者
export const jhhzzrs = (jhhzzrs) =>( http.post_token('back_users/jhhzzrs',jhhzzrs));
//微名片文章数量统计
export const doctors_artcles_tj = (doctors_artcles_tj) =>( http.post_token('back_users/doctors_artcles_tj',doctors_artcles_tj));
//优惠卷批量
export const save_bats = (save_bats) =>( http.post_token('coupons/save_bats',save_bats));
//添加优惠券模板
export const coupons_tpl_save = (coupons_tpl_save) =>( http.post_token('coupons_tpl/coupons_tpl_save',coupons_tpl_save));
//删除优惠卷模板
export const coupons_tpl_delete = (coupons_tpl_delete) =>( http.post_token('coupons_tpl/coupons_tpl_delete',coupons_tpl_delete));
//优惠卷模板列表
export const coupons_tpl_list = (coupons_tpl_list) =>( http.post_token('coupons_tpl/coupons_tpl_list',coupons_tpl_list));
//获取个人优惠卷信息
export const get_doctor_coupons = (get_doctor_coupons) =>( http.post_token('coupons/get_doctor_coupons',get_doctor_coupons));
//删除优惠卷
export const coupons_delete = (coupons_delete) =>( http.post_token('coupons/coupons_delete',coupons_delete));
//授权量
export const yht_wmp_sqtj = (yht_wmp_sqtj) =>( http.post_token('back_users/yht_wmp_sqtj',yht_wmp_sqtj));
//文章阅读量top10
export const yht_artcles_top10 = (yht_artcles_top10) =>( http.post_token('back_users/yht_artcles_top10',yht_artcles_top10));
//文章阅读量统计last10
export const yht_artcles_last10 = (yht_artcles_last10) =>( http.post_token('back_users/yht_artcles_last10',yht_artcles_last10));
//医患通医生统计top10
export const yht_sqlyy_top10 = (yht_sqlyy_top10) =>( http.post_token('back_users/yht_sqlyy_top10',yht_sqlyy_top10));
//医患通医生统计last10
export const yht_sqlyy_last10 = (yht_sqlyy_last10) =>( http.post_token('back_users/yht_sqlyy_last10',yht_sqlyy_last10));
//医患通总的统计
export const yht_tj = (yht_tj) =>( http.post_token('back_users/yht_tj',yht_tj));
//文章免费
export const doctors_artcles_setfree = (doctors_artcles_setfree) =>( http.post_token('back_users/doctors_artcles_setfree',doctors_artcles_setfree));
//文章的推送与分享
export const yht_wmp_pushartclestj = (yht_wmp_pushartclestj) =>( http.post_token('back_users/yht_wmp_pushartclestj',yht_wmp_pushartclestj));
//桌面软件统计
export const pdm_tj = (pdm_tj) =>( http.post_token('back_users/pdm_tj',pdm_tj));


// WEBPACK FOOTER //
// ./src/components/http/api.js